export default __webpack_public_path__ + "static/FHAlphaTest-Light-ae91f09425de78cf1a2b1d45c7c53e38.otf";